import { lazy } from "react";

export const FreemiumBannerAsync = lazy(() => import("./FreemiumBanner"));
